import { Fragment } from "react/jsx-runtime";
import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../../AbstractElements";
import { Blog, BlogGridsTitle } from "../../../../Constants/Constants";
import BlogBody from "./BlogBody/BlogBody";
import BlogFilter from "./BlogFilter/BlogFilter";

const BlogGridsContainer = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle={BlogGridsTitle} parent={Blog} />
      <Container fluid className="blog-grid-page">
        <Row>
          <BlogBody />
          <BlogFilter />
        </Row>
      </Container>
    </Fragment>
  );
};

export default BlogGridsContainer;
